<template>
  <div>
    <!-- <auto-form :fields="fields" :item="item"></auto-form> -->
    <v-stepper class="elevation-0" >
      <v-stepper-header class="elevation-0">
        <template v-for="(sect, index ) in item" >
          <v-stepper-step :step="sect.monthNo" :key="sect.monthNo"  color="green"
            editable
          >
            Tháng {{ sect.monthNo }}
          </v-stepper-step>

          <v-divider
            v-if="index !== item.length - 1"
            :key="index"
          ></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          v-for="(sect, index ) in item"
          :key="sect.monthNo"
          :step="sect.monthNo"
        >
          <v-card
            color="grey lighten-1"
          >
            <v-data-table :items="sect.employeeReviewDetails" :headers="viewHeaders">
              <template v-slot:item.score="{ item }">
              <v-icon v-if="item.score" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
              </template>

              <template v-slot:item.conditionTitle="{ item }">
                <b >{{ item.conditionTitle }}</b>
                <p class="text--body-2">
                  {{ item.conditionBody }}
                </p>
              </template>
              

            </v-data-table>
          
          </v-card>

          <!-- <v-btn
            color="primary"
            @click="nextStep(n)"
          >
            Continue
          </v-btn>

          <v-btn text>
            Cancel
          </v-btn> -->
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <!-- <p v-for="sect in item" :key="sect">
      <v-row>
        <v-col cols="6" md="4">
          <strong>Tháng:</strong> {{ sect.monthNo }} 
        </v-col>
        
        <v-col cols="6" md="4">
          <strong>Điểm:</strong> {{ sect.score }} / {{ sect.maxScore }}
        </v-col>
      </v-row> 
    </p>  -->
    <!-- <v-data-table :items="item.employeeReviewDetails" :headers="viewHeaders">
      <template v-slot:item.score="{ item }">
        <v-icon v-if="item.score" color="green">mdi-check</v-icon>
        <v-icon v-if="!item.score" color="red">mdi-close</v-icon>
      </template>
    </v-data-table> -->
  </div>
</template>

<script>

import AutoForm from '@/components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import { view } from './header'
export default {
  props: {
    item: {
      type: Object
    },
  },
  components: {
    AutoForm
  },
  computed: {
    fields () {
      return [
        {name: 'id', label:'Id', type: 'text-field', value: this.item?.id, cols: 12 },
        {name: 'employeeCode', label:'Mã nhân viên', type: 'text-field', value: this.item?.employeeCode, cols: 12, md:6 },
        {name: 'employeeName', label:'Tên nhân viên', type: 'text-field', value: this.item?.employeeName, cols: 12, md:6 },
        {name: 'validFrom', label:'Bắt đầu', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validFrom, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'validTo', label:'Kết thúc', type: 'text-field', isDate: true, value: this.$formatter.formatDate(this.item?.validTo, 'YYYY-MM-DD'), cols: 12, md:6 },
        {name: 'score', label:'Đánh giá', type: 'text-field', value: `${this.item?.score ?? 0}/${this.item?.maxScore}`, cols: 12, md:6 },
        // {name: 'comments', label:'Bình luận', type: 'text-field', value: this.item?.comments, cols: 12, md:12 },
      ]
    },
    
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
      // slots: ['score']
    }
  },
  methods: {

  }

}
</script>